import * as React from 'react';
import styles from './index.less';
import img_banner from './banner@3x.png';
import img_img1 from './img1@2x.png';
import img_img2 from './img2@2x.png';
import img_img3 from './img3@2x.png';
import img_img41 from './img4.1@2x.png';
import img_img42 from './img4.2@2x.png';
import img_img5 from './img5@2x.png';
import img_bgLeft from './bgLeft@2x.png';
import img_bgRight from './bgRight@2x.png';
import img_yubi from './yubi@2x.png';
import FPropaganda from '@/components/FPropaganda';
import FPageFooter from '@/components/FPageFooter';
import AboutUs from '@/pages/activity/$id/SpringFestival2025/AboutUs';
import { Modal } from 'antd';
import { FServiceAPI, FUtil } from '@freelog/tools-lib';
import * as AHooks from 'ahooks';
import FComponentsLib from '@freelog/components-lib';
import FCoverImage from '@/components/FCoverImage';
import FCopyToClipboard from '@/components/FCopyToClipboard';
import dayjs from 'dayjs';
import FSimpleBar from '@/components/FSimpleBar';

interface SpringFestival2025Props {}

function SpringFestival2025({}: SpringFestival2025Props) {
  const [$momentTime, set$momentTime, get$momentTime] =
    FUtil.Hook.useGetState<dayjs.Dayjs>(dayjs());
  const [$ruleShow, set$ruleShow, get$ruleShow] = FUtil.Hook.useGetState<boolean>(false);
  const [$announceShow, set$announceShow, get$announceShow] =
    FUtil.Hook.useGetState<boolean>(false);
  const [$isRegister, set$isRegister, get$isRegister] = FUtil.Hook.useGetState<boolean>(false);
  const [$announceTime, set$announceTime, get$announceTime] = FUtil.Hook.useGetState<dayjs.Dayjs>(
    dayjs('2025-01-26 00:00:00'),
  );

  const [$isProdEnv] = FUtil.Hook.useGetState<boolean>(
    self.location.hostname.endsWith('.freelog.cn'),
  );
  // console.log($isProdEnv, '$isProdEnviosdjfl;ksdjlfjlkjl');
  AHooks.useMount(async () => {
    if (FUtil.Tool.getUserIDByCookies() === -1) {
      return;
    }
    const {
      data,
    }: {
      data: {
        userType: 0 | 1;
      };
    } = await FServiceAPI.User.currentUserInfo();
    set$isRegister(data.userType === 1);
  });

  return (
    <>
      <div className={styles.styles}>
        <img
          src={img_banner}
          alt={''}
          style={{
            display: 'block',
            width: '100%',
          }}
        />
        <div
          style={{
            marginTop: -80,
            // backgroundColor: 'red',
            height: 'fit-content',
            position: 'relative',
          }}
        >
          <img
            src={img_bgRight}
            alt={''}
            style={{
              display: 'block',
              width: 300,
              position: 'absolute',
              right: 0,
              top: 120,
            }}
          />

          <img
            src={img_bgLeft}
            alt={''}
            style={{
              display: 'block',
              width: 300,
              position: 'absolute',
              left: 0,
              top: 500,
            }}
          />

          <img
            src={img_bgRight}
            alt={''}
            style={{
              display: 'block',
              width: 300,
              position: 'absolute',
              right: 0,
              top: 900,
            }}
          />

          <img
            src={img_bgLeft}
            alt={''}
            style={{
              display: 'block',
              width: 300,
              position: 'absolute',
              left: 0,
              top: 1300,
            }}
          />

          <img
            src={img_bgRight}
            alt={''}
            style={{
              display: 'block',
              width: 300,
              position: 'absolute',
              right: 0,
              top: 1670,
            }}
          />

          <img
            src={img_bgLeft}
            alt={''}
            style={{
              display: 'block',
              width: 300,
              position: 'absolute',
              left: 0,
              top: 2100,
            }}
          />

          <img
            src={img_bgRight}
            alt={''}
            style={{
              display: 'block',
              width: 300,
              position: 'absolute',
              right: 0,
              top: 2430,
            }}
          />

          <img
            src={img_bgLeft}
            alt={''}
            style={{
              display: 'block',
              width: 300,
              position: 'absolute',
              left: 0,
              top: 2820,
            }}
          />

          <img
            src={img_bgRight}
            alt={''}
            style={{
              display: 'block',
              width: 300,
              position: 'absolute',
              right: 0,
              top: 3200,
            }}
          />

          <img
            src={img_bgLeft}
            alt={''}
            style={{
              display: 'block',
              width: 300,
              position: 'absolute',
              left: 0,
              top: 3560,
            }}
          />

          <img
            src={img_bgRight}
            alt={''}
            style={{
              display: 'block',
              width: 300,
              position: 'absolute',
              right: 0,
              top: 3960,
            }}
          />

          <img
            src={img_bgLeft}
            alt={''}
            style={{
              display: 'block',
              width: 300,
              position: 'absolute',
              left: 0,
              top: 4360,
            }}
          />

          <img
            src={img_bgRight}
            alt={''}
            style={{
              display: 'block',
              width: 300,
              position: 'absolute',
              right: 0,
              top: 4760,
            }}
          />

          <img
            src={img_bgLeft}
            alt={''}
            style={{
              display: 'block',
              width: 300,
              position: 'absolute',
              left: 0,
              top: 5120,
            }}
          />

          <img
            src={img_bgRight}
            alt={''}
            style={{
              display: 'block',
              width: 300,
              position: 'absolute',
              right: 0,
              top: 5520,
            }}
          />

          <img
            src={img_img1}
            alt={''}
            style={{
              display: 'block',
              width: 1060,
              margin: '0 auto',
            }}
          />
          <div style={{ height: 120 }} />
          <img
            src={img_img2}
            alt={''}
            style={{
              display: 'block',
              width: 1060,
              margin: '0 auto',
            }}
          />
          <div style={{ height: 120 }} />
          <img
            src={img_img3}
            alt={''}
            style={{
              display: 'block',
              width: 1060,
              margin: '0 auto',
            }}
          />
          <div style={{ height: 106 }} />

          <div
            style={{
              height: 54,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {$momentTime.isAfter($announceTime) ? (
              <div
                className={styles.ButtonNormal}
                onClick={() => {
                  set$announceShow(true);
                }}
              >
                查看获奖公示
              </div>
            ) : (
              <div
                style={{
                  fontWeight: 400,
                  fontSize: 16,
                  color: '#222',
                  lineHeight: '22px',
                }}
              >
                获奖公示时间：
                {
                  // $announceTime.format('YYYY-MM-DD HH:mm:ss')
                  $announceTime.format('YYYY/MM/DD')
                }
                ，敬请关注
              </div>
            )}
          </div>
          <div style={{ height: 120 }} />
          <img
            src={img_img41}
            alt={''}
            style={{
              display: 'block',
              width: 1060,
              margin: '0 auto',
            }}
          />
          <div style={{ height: 40 }} />
          <div
            style={{
              height: 54,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {$isRegister && (
              <div className={[styles.ButtonNormal, styles.disabled].join(' ')}>已获资格</div>
            )}

            {!$isRegister && (
              <div
                className={styles.ButtonNormal}
                onClick={async () => {
                  const {
                    data,
                  }: {
                    data: {
                      userType: 0 | 1;
                    };
                  } = await FServiceAPI.User.currentUserInfo();

                  if (FUtil.Tool.getUserIDByCookies() === -1) {
                    return;
                  }

                  self.open(
                    FUtil.Format.completeUrlByDomain('console') +
                      FUtil.LinkTo.invitation() +
                      '?type=apply',
                  );
                }}
              >
                提交内测申请
              </div>
            )}
          </div>
          <div style={{ height: 70 }} />
          <img
            src={img_img42}
            alt={''}
            style={{
              display: 'block',
              width: 1060,
              margin: '0 auto',
            }}
          />
          <div style={{ height: 70 }} />
          <div
            style={{
              // height: 334,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div style={{ position: 'relative' }}>
              <div
                style={{
                  position: 'absolute',
                  top: -350,
                  left: -178,
                }}
              >
                <FCopyToClipboard text={'Freelog插画贺岁纪'} title={'点击复制标签'}>
                  <div className={styles.ButtonBorderRadius}>#Freelog插画贺岁纪#</div>
                </FCopyToClipboard>
              </div>
              <div
                className={styles.ButtonBig}
                onClick={() => {
                  self.open(
                    FUtil.Format.completeUrlByDomain('console') +
                      FUtil.LinkTo.resourceCreatorEntry(),
                  );
                }}
              >
                立即投稿
              </div>
              <div style={{ height: 20 }} />
              <div
                style={{
                  width: 485,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <div
                  className={styles.ButtonTransparent}
                  onClick={() => {
                    // self.open('https://freelog3.freelog.com/?theme=%2Freader%3Fid%25M262ce6f8a456ff0002e32915f%25M1title%25M2%EF%BC%88%E4%B8%89%EF%BC%89%E5%8F%91%E8%A1%8C%E5%90%88%E9%9B%86%E8%B5%84%E6%BA%90&w06c513=%2F%C2%A0');
                    self.open(
                      'https://freelog3.freelog.cn/?theme=%2Freader%3Fid%25M262ce6f8a456ff0002e32915f&w06c513=%2F',
                    );
                  }}
                >
                  查看教程
                </div>
                <div
                  className={styles.ButtonTransparent}
                  onClick={() => {
                    set$ruleShow(true);
                  }}
                >
                  查看活动规则
                </div>
              </div>
            </div>
          </div>
          <div style={{ height: 120 }} />
          <img
            src={img_img5}
            alt={''}
            style={{
              display: 'block',
              width: 1060,
              margin: '0 auto',
            }}
          />
          <div style={{ height: 40 }} />

          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <AboutUs />
          </div>
          <div style={{ height: 120 }} />
        </div>

        <div style={{ background: 'rgba(255,255,255,0.4)' }}>
          <FPropaganda />
          <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <div style={{ border: '1px solid #979797', width: 680, opacity: 0.15 }} />
          </div>
          <FPageFooter />
        </div>
      </div>

      <Modal
        // open={true}
        open={$announceShow}
        title={null}
        footer={null}
        width={1000}
        centered={true}
        style={{ borderRadius: 10, overflow: 'hidden' }}
        styles={{
          body: {
            padding: 0,
            height: '100%',
            width: '100%',
          },
          content: {
            padding: 0,
            height: 'calc(100vh - 200px)',
          },
        }}
        onCancel={() => {
          set$announceShow(false);
        }}
      >
        <FSimpleBar>
          <div className={styles.announceModalBody}>
            <div className={styles.announceModalBodyContent}>
              <img
                src={img_bgRight}
                alt={''}
                style={{
                  display: 'block',
                  width: 300,
                  position: 'absolute',
                  right: 0,
                  top: 200,
                }}
              />

              <img
                src={img_bgLeft}
                alt={''}
                style={{
                  display: 'block',
                  width: 300,
                  position: 'absolute',
                  left: 0,
                  top: 580,
                }}
              />

              <img
                src={img_bgRight}
                alt={''}
                style={{
                  display: 'block',
                  width: 300,
                  position: 'absolute',
                  right: 0,
                  top: 960,
                }}
              />

              <img
                src={img_bgLeft}
                alt={''}
                style={{
                  display: 'block',
                  width: 300,
                  position: 'absolute',
                  left: 0,
                  top: 1330,
                }}
              />

              <img
                src={img_bgRight}
                alt={''}
                style={{
                  display: 'block',
                  width: 300,
                  position: 'absolute',
                  right: 0,
                  top: 1720,
                }}
              />

              <img
                src={img_bgLeft}
                alt={''}
                style={{
                  display: 'block',
                  width: 300,
                  position: 'absolute',
                  left: 0,
                  top: 2120,
                }}
              />

              <div style={{ height: 40 }} />
              <div className={styles.h1}>获奖公示</div>
              <div style={{ height: 90 }} />
              <div className={styles.h2}>贺岁纪 · 优秀作品奖</div>
              <div style={{ height: 50 }} />
              <div className={styles.h3}>一等奖 1 个</div>
              <div style={{ height: 20 }} />
              <div className={styles.cards}>
                <AnnounceCard
                  resourceID={$isProdEnv ? '677f31d60d411d002fca054d' : '67764c36529799002f8f8e57'}
                />
              </div>
              <div style={{ height: 50 }} />
              <div className={styles.h3}>二等奖 3 个</div>
              <div style={{ height: 20 }} />
              <div className={styles.cards}>
                <AnnounceCard
                  resourceID={$isProdEnv ? '6760698c0d411d002fc7b4c6' : '67764c36529799002f8f8e57'}
                />
                <AnnounceCard
                  resourceID={$isProdEnv ? '6775f78c0d411d002fc97873' : '67764c36529799002f8f8e57'}
                />
                <AnnounceCard
                  resourceID={$isProdEnv ? '676e94e90d411d002fc8fdfc' : '67764c36529799002f8f8e57'}
                />
              </div>
              <div style={{ height: 50 }} />
              <div className={styles.h3}>三等奖 6 个</div>
              <div style={{ height: 20 }} />
              <div className={styles.cards}>
                <AnnounceCard
                  resourceID={$isProdEnv ? '675fd4c20d411d002fc7a8ed' : '67764c36529799002f8f8e57'}
                />
                <AnnounceCard
                  resourceID={$isProdEnv ? '676284d10d411d002fc7e92a' : '67764c36529799002f8f8e57'}
                />
                <AnnounceCard
                  resourceID={$isProdEnv ? '6772067f0d411d002fc9212a' : '67764c36529799002f8f8e57'}
                />
                <AnnounceCard
                  resourceID={$isProdEnv ? '6780b981652c70002f4c1b6a' : '67764c36529799002f8f8e57'}
                />
                <AnnounceCard
                  resourceID={$isProdEnv ? '67828233652c70002f4c47a5' : '67764c36529799002f8f8e57'}
                />
                <AnnounceCard
                  resourceID={$isProdEnv ? '677254b70d411d002fc93ff7' : '67764c36529799002f8f8e57'}
                />
              </div>

              <div style={{ height: 90 }} />
              <div className={styles.h2}>贺岁纪 • 创作达人奖</div>
              <div style={{ height: 50 }} />
              <div className={styles.h3}>累计发布有效作品数量排名前三的创作者</div>
              <div style={{ height: 20 }} />
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div
                  style={{
                    fontSize: 14,
                    color: '#666',
                    lineHeight: '20px',
                  }}
                >
                  Lvdouzi88
                </div>
                <div style={{ width: 10 }} />
                <div
                  style={{
                    fontSize: 14,
                    color: '#E37E1D',
                    lineHeight: '20px',
                  }}
                >
                  ¥200
                </div>
                <div style={{ width: 50 }} />
                <div
                  style={{
                    fontSize: 14,
                    color: '#666',
                    lineHeight: '20px',
                  }}
                >
                  zhubu
                </div>
                <div style={{ width: 10 }} />
                <div
                  style={{
                    fontSize: 14,
                    color: '#E37E1D',
                    lineHeight: '20px',
                  }}
                >
                  ¥200
                </div>
                <div style={{ width: 50 }} />
                <div
                  style={{
                    fontSize: 14,
                    color: '#666',
                    lineHeight: '20px',
                  }}
                >
                  YZ
                </div>
                <div style={{ width: 10 }} />
                <div
                  style={{
                    fontSize: 14,
                    color: '#E37E1D',
                    lineHeight: '20px',
                  }}
                >
                  ¥200
                </div>
              </div>

              <div style={{ height: 90 }} />
              <div className={styles.h2}>贺岁纪 • 全民瓜分奖</div>
              <div style={{ height: 50 }} />
              <div className={styles.h3}>活动最终奖池解锁至888元，感谢大家的热情参与！</div>

              <div style={{ height: 90 }} />
              <div className={styles.h2}>贺岁纪 • 幸运奖</div>
              <div style={{ height: 50 }} />
              <div className={styles.h3}>10位幸运用户，每位奖励¥88</div>
              <div style={{ height: 20 }} />

              <NameList
                names={[
                  'Heidi',
                  'yangyang',
                  'sheYYAYAY',
                  'Zhe',
                  'island',
                  'xtxt',
                  'myydesigner',
                  'millionyoyoy',
                  'xinyouxin',
                  'YET',
                ]}
              />

              <div style={{ height: 90 }} />

              <div
                style={{
                  fontSize: 12,
                  color: '#999',
                  lineHeight: '18px',
                  textAlign: 'center',
                }}
              >
                <div>
                  奖励将在结果公示期结束后，即在官方公布最终获奖名单后的15个工作日内，发放至获奖用户的Freelog账号名下
                </div>
              </div>

              <div style={{ height: 60 }} />
            </div>
          </div>
        </FSimpleBar>
      </Modal>

      <Modal
        open={$ruleShow}
        // open={true}
        title={null}
        footer={null}
        // closable={false}
        width={1000}
        centered={true}
        style={{ borderRadius: 10, overflow: 'hidden' }}
        bodyStyle={{ height: 'calc(100vh - 200px)', padding: 0 }}
        onCancel={() => {
          set$ruleShow(false);
        }}
      >
        <div className={styles.ruleModalBody}>
          <div
            style={{
              backgroundColor: '#FFF1D4',
              position: 'relative',
            }}
          >
            <img
              src={img_bgRight}
              alt={''}
              style={{
                display: 'block',
                width: 300,
                position: 'absolute',
                right: 0,
                top: 200,
              }}
            />

            <img
              src={img_bgLeft}
              alt={''}
              style={{
                display: 'block',
                width: 300,
                position: 'absolute',
                left: 0,
                top: 580,
              }}
            />

            <img
              src={img_bgRight}
              alt={''}
              style={{
                display: 'block',
                width: 300,
                position: 'absolute',
                right: 0,
                top: 960,
              }}
            />

            <img
              src={img_bgLeft}
              alt={''}
              style={{
                display: 'block',
                width: 300,
                position: 'absolute',
                left: 0,
                top: 1330,
              }}
            />

            <img
              src={img_bgRight}
              alt={''}
              style={{
                display: 'block',
                width: 300,
                position: 'absolute',
                right: 0,
                top: 1720,
              }}
            />

            <img
              src={img_bgLeft}
              alt={''}
              style={{
                display: 'block',
                width: 300,
                position: 'absolute',
                left: 0,
                top: 2120,
              }}
            />

            <div className={styles.ruleModalContent}>
              <div style={{ height: 40 }} />
              <div className={styles.h1}>活动规则</div>
              <div className={styles.h2}>1、活动时间</div>
              <div className={styles.h3}>1.1 活动期限</div>
              <div className={styles.content}>本活动自2024-12-12起，至2025-01-15止。</div>
              <div className={styles.h3}>1.2 结果公示</div>
              <div className={styles.content}>
                活动结束后到2025-01-26为活动评选阶段，最终活动结果将于2025-01-26公布。
              </div>
              <div className={styles.h3}>1.3 参与建议</div>
              <div className={styles.content}>
                为保证您的活动参与体验，请尽量使用PC端访问freelog网页版。
              </div>
              <div className={styles.h2}>2、活动奖项设置</div>
              <div className={styles.h3}>2.1 贺岁纪 • 优秀作品奖</div>
              <div className={styles.content}>
                ·&nbsp;&nbsp;&nbsp;一等奖1个，对每位作品创作者奖励1000元；
              </div>
              <div className={styles.content}>
                ·&nbsp;&nbsp;&nbsp;二等奖3个，对每位作品创作者奖励500元；
              </div>
              <div className={styles.content}>
                ·&nbsp;&nbsp;&nbsp;三等奖6个，对每位作品创作者奖励200元。
              </div>
              <div className={styles.h3}>2.2 贺岁纪 • 创作达人奖</div>
              <div className={styles.content}>
                ·&nbsp;&nbsp;&nbsp;活动参与者中，累计发布有效作品数量排名前三的创作者将分别获得200元的创作达人激励奖金。
              </div>
              <div className={styles.h3}>2.3 贺岁纪 • 全民瓜分奖</div>
              <div className={styles.content}>
                ·&nbsp;&nbsp;&nbsp;只要创作者成功发布至少一个符合活动标准的插画作品，即可获得参与全民瓜分奖的资格。
              </div>
              <div className={styles.content}>·&nbsp;&nbsp;&nbsp;初始奖池 → ¥88</div>
              <div className={styles.content}>·&nbsp;&nbsp;&nbsp;参与≥20人 → 解锁¥188奖池</div>
              <div className={styles.content}>·&nbsp;&nbsp;&nbsp;参与≥50人 → 解锁¥888奖池</div>
              <div className={styles.content}>·&nbsp;&nbsp;&nbsp;参与≥100人 → 解锁¥3888奖池</div>
              <div className={styles.h3}>2.4 贺岁纪 • 幸运奖</div>
              <div className={styles.content}>
                ·&nbsp;&nbsp;&nbsp;活动将从所有成功参与的用户中挑选出10位幸运儿，每位将获得88元奖励。
              </div>
              <div className={styles.h2}>3、活动参与方式</div>
              <div className={styles.h3}>3.1 内测资格获取</div>
              <div className={styles.content} style={{ paddingLeft: 0 }}>
                内测资格获取：所有参与用户需获得Freelog内测资格。已获得内测资格的用户可以直接参与活动。未获得内测资格的用户需在Freelog平台（
                <a href={'https://www.freelog.cn'} target={'_blank'}>
                  www.freelog.cn
                </a>
                ）完成注册，并提交内测资格申请或联系官方工作人员获取邀请码。
              </div>
              <div className={styles.h3}>3.2 开启投稿之旅</div>
              <div className={styles.content}>
                ·&nbsp;&nbsp;&nbsp;参与此次活动的创作者们，通过活动页面的“立即投稿”入口，进入“创建资源”页面，进入创建资源流程后，需选择上传的资源类型为“图片”——“插画”；
              </div>
              <div className={styles.content}>
                ·&nbsp;&nbsp;&nbsp;参与此次活动的创作者们，需在“提交资源文件”步骤中，上传包含传统春节元素或生肖蛇年元素的插画作品，图片要求JPEG/PNG格式，分辨率不低于72dpi；
              </div>
              <div className={styles.content}>
                ·&nbsp;&nbsp;&nbsp;参与此次活动的创作者们，需在“添加授权策略”步骤中，为上传的插画作品添加一个授权策略，以确保其能够成功在资源市场上架；
              </div>
              <div className={styles.content}>
                ·&nbsp;&nbsp;&nbsp;参与此次活动的创作者们，需在“完善资源信息”步骤中，为上传的插画作品添加专属活动标签——#Freelog插画贺岁纪#并点击上架，即可完成投稿之旅。
              </div>
              <div className={styles.h2}>4、活动参与要求</div>
              <div className={styles.h3}>4.1 无效资源</div>
              <div className={styles.content}>
                严禁上传空白文件、无实质内容的资源，以及其他任何形式的虚假或无意义资源。一经发现，相关资源将无法参与活动评选。
              </div>
              <div className={styles.h3}>4.2 保持上架</div>
              <div className={styles.content}>
                参与本次活动的资源和展品必须在活动结算之前保持上架状态，否则，可能会影响活动奖励的发放。
              </div>
              <div className={styles.h3}>4.3 活动资源原创性与版权规则</div>
              <div className={styles.content}>
                ·&nbsp;&nbsp;&nbsp;用户发布的资源必须为原创作品，禁止抄袭、搬运、代投、恶意二改（即未经授权对他人作品进行修改，尤其是以损害原作品完整性或原始意图的方式）他人内容等，此外，本次活动不接受任何形式的人工智能（AI）生成的插画作品；
              </div>
              <div className={styles.content}>
                ·&nbsp;&nbsp;&nbsp;对于合作创作的资源，参与各方应协商一致，通过一个指定的特定账号进行发布。严禁多人使用各自账号重复发布相同或相似的合作资源；
              </div>
              <div className={styles.content}>
                ·&nbsp;&nbsp;&nbsp;用户需确保对发布的资源拥有完整的著作权或已获得必要的授权，若因未获得授权或侵犯他人版权导致任何法律纠纷，Freelog平台不承担任何法律责任。相关责任由侵权用户自行承担；
              </div>
              <div className={styles.content}>
                ·&nbsp;&nbsp;&nbsp;一经发现用户有违反上述原创性与版权规则的，其相关资源将无法参与活动评选。
              </div>
              <div className={styles.h3}>4.4 活动资源原创性与版权规则</div>
              <div className={styles.content}>
                所有用户须遵守
                <a
                  href={
                    'https://freelog2.freelog.cn/reader_freelog-query_id=62cce8f2456ff0002e328eb2 '
                  }
                  target={'_blank'}
                >
                  《Freelog平台管理规范》
                </a>
                ，一经发现用户存在违反平台管理规范的行为，其相关资源将无法参与活动评选。
              </div>
              <div className={styles.h2}>5、活动常见Q&A：</div>
              <div className={styles.h3}>5.1 如何在授权合约流程中使用真实货币交易</div>
              <div className={styles.content}>
                内测期间，Freelog暂不支持真实货币交易，为了便于用户体验资源授权合约交易中的付费相关功能，Freelog提供虚拟币——“羽币”支持。
              </div>
              <div className={styles.content}>
                内测期间，羽币与真实货币无任何联系，Freelog平台不支持以任何形式、任何比例进行羽币与真实货币之间的兑换。
              </div>
              <div className={styles.h3}>5.2 如何领取羽币</div>
              <div className={styles.content}>
                用户可以通过点击【个人中心】—【我的钱包】进入“羽币账户”界面，先点击激活您的羽币账户后，点击下方【立即领取】按钮即可领取100枚内测羽币。
              </div>
              <div className={styles.content}>
                <img src={img_yubi} alt={''} style={{ width: '100%', position: 'relative' }} />
              </div>
              <div className={styles.content}>
                更多活动问题答疑详见{' '}
                <a
                  href={
                    'https://freelog3.freelog.cn/home_freelog-query_id=62d0d04f456ff0002e329537'
                  }
                  target={'_blank'}
                >
                  常见问题
                </a>
              </div>
              <div className={styles.h2}>6、违规举报</div>
              <div className={styles.content}>
                活动期间开放举报通道，用户可以通过联系官方工作人员或向Freelog发送邮件（
                service@freelog.com ）对涉嫌违规的行为和用户进行举报。
                举报邮件内容需包含被举报作品名称、作品链接、涉嫌违规原因，否则不予处理；
              </div>
              <div className={styles.h2}>7、平台声明</div>
              <div className={styles.content}>
                活动最终解释权归Freelog所有，如有疑问请联系官方工作人员或发送邮件至官方邮箱
                service@freelog.com。
              </div>
              <div style={{ height: 60 }} />
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default SpringFestival2025;

interface AnnounceCardProps {
  resourceID: string;
}

export function AnnounceCard({ resourceID }: AnnounceCardProps) {
  const [$resource, set$resource, get$resource] = FUtil.Hook.useGetState<null | {
    resourceID: string;
    cover: string;
    title: string;
    avatar: string;
    username: string;
    href: string;
  }>(null);

  AHooks.useMount(async () => {
    // @ts-ignore
    const {
      data: data_resource,
    }: {
      data: {
        resourceId: string;
        resourceName: string;
        resourceTitle: string;
        coverImages: string[];
        userId: number;
        subjectType: 1 | 4;
      };
    } = await FServiceAPI.Resource.info({
      resourceIdOrName: resourceID,
    });

    const {
      data: data_user,
    }: {
      data: {
        userId: number;
        headImage: string;
        username: string;
      };
    } = await FServiceAPI.User.userDetails({
      userId: data_resource.userId,
    });

    // console.log(data_resource, data_user);
    set$resource({
      resourceID: resourceID,
      cover: data_resource.coverImages[0] || '',
      title: data_resource.resourceTitle,
      avatar: data_user.headImage,
      username: data_user.username,
      href: `${FUtil.Format.completeUrlByDomain('console')}${
        data_resource.subjectType === 4
          ? FUtil.LinkTo.collectionDetails({
              collectionID: resourceID,
            })
          : FUtil.LinkTo.resourceDetails({
              resourceID: resourceID,
            })
      }`,
    });
    // console.log(get$resource());
  });

  if (!$resource) {
    return null;
  }

  return (
    <div
      className={styles.AnnounceCard}
      onClick={() => {
        self.open(
          FUtil.Format.completeUrlByDomain('console') +
            FUtil.LinkTo.resourceDetails({
              resourceID: resourceID,
            }),
        );
      }}
    >
      <FCoverImage src={$resource.cover} width={240} className={styles.AnnounceCardCover} />
      <div style={{ height: 10 }} />
      <div className={styles.AnnounceCardTitle}>{$resource.title}</div>
      <div style={{ height: 15 }} />
      <div className={styles.AnnounceCardUserInfo}>
        <img src={$resource.avatar} alt={''} />
        <FComponentsLib.FContentText
          type={'additional2'}
          style={{ color: '#666', maxWidth: 200 }}
          singleRow
          text={$resource.username}
        />
      </div>
    </div>
  );
}

interface NameListProps {
  names: string[];
}

function NameList({ names }: NameListProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', padding: '0 100px' }}>
      {names.map((n, ni) => {
        return (
          <React.Fragment key={ni}>
            {ni % 3 === 0 && (
              <div style={{ borderTop: '1px solid rgba(0,0,0,.1)', flexBasis: '100%' }} />
            )}
            <div style={{ flexBasis: '33.33%', height: 50, alignItems: 'center', display: 'flex' }}>
              {n}
            </div>
          </React.Fragment>
        );
      })}
      <div style={{ borderTop: '1px solid rgba(0,0,0,.1)', flexBasis: '100%' }} />
    </div>
  );
}
